<template>
  <div class="page">
    <BackLink
      :route-from="currentUsergroup ? {
        name: currentUsergroup.organisation ? 'OrganisationDetail' : 'GroupDetail',
        params: {
          id: currentUsergroup.organisation ? currentUsergroup.organisation.id : currentUsergroup.id
        }
      } : null"
      route-name="Accounts"
      :title="currentUsergroup ? currentUsergroup.display_name : capitalizeFirstLetter($t('words.accountsManagement'))"
    />
    <div class="container-xl">
      <b-overlay
        no-wrap
        :show="loading"
        variant="light"
        opacity="0.5"
        rounded="false"
      />
      <h2>
        {{ $t('indexers.new') }}
      </h2>
      <h6>
        Configurer votre moissonneur
      </h6>
      <ValidationObserver v-slot="{ handleSubmit }">
        <IndexerForm @set="setForm" />
        <div class="row mt-3">
          <div class="col indexer-form-footer">
            <div />
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="handleSubmit(createIndexer)"
            >
              {{ capitalizeFirstLetter($t('words.create')) }}
            </button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import BackLink from '@/components/Elements/BackLink.vue';
import IndexerForm from '@/app/indexer/components/IndexerForm.vue';

import { ValidationObserver } from 'vee-validate';

export default {
  name: 'AddIndexer',

  components: {
    BackLink,
    IndexerForm,
    ValidationObserver
  },

  data() {
    return {
      loading: false,
      formData: null
    };
  },

  computed: {
    ...mapState('usergroups', [
      'currentUsergroup'
    ]),
    ...mapState('indexers', [
      'currentIndexer'
    ])
  },

  mounted() {
    // TODO: set scrollBehavior in router
    // TODO: (use meta field to change behavior between pages + use back-lnk as anchor)
    const pageTop = document.getElementsByClassName('back-link')[0];
    pageTop.scrollIntoView({ behavior: 'smooth' });
  },

  methods: {
    ...mapActions('indexers', [
      'CREATE_INDEXER'
    ]),

    setForm(e) {
      this.formData = e;
    },

    async createIndexer() {
      try {
        this.loading = true;
        const data = {
          name: this.formData.name,
          ...this.formData.description && {
            description: this.formData.description
          },
          options: {
            url: this.formData.url,
            href_pattern: this.formData.pattern,
            ...this.formData.organisation && {
              organisation: [this.formData.organisation]
            },
            // force_organisation: this.formData.forcedOrganisations,
          },
          command: this.formData.command.value,
          // scheduler: this.formData.scheduler,
          usergroup_id: this.$route.params.usergroupId
        };
        await this.CREATE_INDEXER(data);
        this.$router.push({
          name: 'IndexerDetail',
          params: {
            usergroupId: this.$route.params.usergroupId,
            indexerId: this.currentIndexer.id
          }
        });
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
h2, h6 {
  color: @blue;
}
.indexer-form-footer {
  display: flex;
  justify-content: space-between;
}
</style>